module.exports = __webpack_public_path__ + "img/toggle.96d4c187.svg";